import axios from "../../utils/axios";

export type TabCriteriaStateResponse = {
    isReadonly: boolean;
    readonlyReason: string;
}

export const getTabCriteriaState = (rfpId: string) => axios
    .get(`/api/v1/frontend/tenders/facility-manager/${ rfpId }/tab-criteria-state`)
    .then((response: { data: { data: TabCriteriaStateResponse } }) => response.data.data)
